module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', [_c('h3', [_vm._v("Seleccionar trabajadores")]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.nombreArea))])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": _vm.cerrar
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "busqueda"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.textoBusqueda),
      expression: "textoBusqueda",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre o código..."
    },
    domProps: {
      "value": (_vm.textoBusqueda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textoBusqueda = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "seleccionar-todos"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.todosSeleccionados
    },
    on: {
      "change": _vm.seleccionarTodos
    }
  }), _c('span', [_vm._v("Seleccionar todos")])]), _c('span', {
    staticClass: "contador"
  }, [_vm._v(_vm._s(_vm.seleccionTemporal.length) + " de\n" + _vm._s(_vm.trabajadoresFiltrados.length) + " seleccionados")])]), (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v("Cargando trabajadores...")])]) : (_vm.trabajadoresFiltrados.length === 0) ? _c('div', {
    staticClass: "sin-resultados"
  }, [_c('span', [_vm._v("No se encontraron trabajadores en esta área.")])]) : _c('div', {
    staticClass: "lista-trabajadores"
  }, _vm._l((_vm.trabajadoresFiltrados), function(trabajador) {
    return _c('label', {
      key: trabajador.codigo,
      staticClass: "trabajador",
      class: {
        'seleccionado': _vm.estaSeleccionado(trabajador)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.seleccionTemporal),
        expression: "seleccionTemporal"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": trabajador.codigo,
        "checked": Array.isArray(_vm.seleccionTemporal) ? _vm._i(_vm.seleccionTemporal, trabajador.codigo) > -1 : (_vm.seleccionTemporal)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.seleccionTemporal,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = trabajador.codigo,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.seleccionTemporal = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.seleccionTemporal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.seleccionTemporal = $$c
          }
        }
      }
    }), _c('div', {
      staticClass: "datos-trabajador"
    }, [_c('span', {
      staticClass: "nombre"
    }, [_vm._v(_vm._s(trabajador.nombre))]), _c('span', {
      staticClass: "detalle"
    }, [_vm._v("Código: " + _vm._s(trabajador.codigo)), (trabajador.cargo) ? _c('span', [_vm._v(" - " + _vm._s(trabajador.cargo))]) : _vm._e()])])])
  }), 0)]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "button button-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cerrar
    }
  }, [_c('span', [_vm._v("Cancelar")])]), _c('button', {
    staticClass: "button button-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.seleccionTemporal.length === 0
    },
    on: {
      "click": _vm.aceptar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v("Aceptar"), (_vm.seleccionTemporal.length) ? [_vm._v(" (" + _vm._s(_vm.seleccionTemporal.length) + ")")] : _vm._e()], 2)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-228225cd","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_modal_trabajadores_area.vue
// module id = 837
// module chunks = 0